export const DEBUGINFO_REQUEST = "DEBUGINFO_REQUEST";
export const DEBUGINFO_SUCCESS = "DEBUGINFO_SUCCESS";
export const DEBUGINFO_FAILURE = "DEBUGINFO_FAILURE";